import { FontSize100, ColorGreen500 } from "@nxt-costco-com/forge-design-tokens";
const instantSavingsStyles = {
  color: ColorGreen500,
  fontSize: FontSize100
};
export {
  instantSavingsStyles
};
